export default __webpack_public_path__ + "static/media/GradientIndoorTop.7c03218d.svg";